import React from 'react';
import defaultContent from '../../content';
import { parseSafeHtml } from '../../utils/safe-html';

type Props = {
  header?: string;
  content: string;
  className?: string;
};

function Notification({ header, content, className }: Props) {
  const id = React.useId();
  return (
    <section
      className={`govuk-notification-banner${className ? ` ${className}` : ''}`}
      aria-labelledby={id}
      data-testid="notification-banner"
    >
      <div className="govuk-notification-banner__header">
        <h2 className="govuk-notification-banner__title" id={id}>
          {header || defaultContent.noticeHeaderDefault}
        </h2>
      </div>
      <div className="govuk-notification-banner__content">
        {/* Avoid govuk-body margins here; we just want the banner's default spacing. */}
        <p className="govuk-notification-banner__heading">{parseSafeHtml(content)}</p>
      </div>
    </section>
  );
}

export default Notification;
